import { render, staticRenderFns } from "./ads.vue?vue&type=template&id=5cbe991c&scoped=true"
import script from "./ads.vue?vue&type=script&lang=js"
export * from "./ads.vue?vue&type=script&lang=js"
import style0 from "./ads.vue?vue&type=style&index=0&id=5cbe991c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbe991c",
  null
  
)

export default component.exports